import React from 'react'
import PropTypes from 'prop-types'
import { Selector } from '@leverege/ui-elements'
import style from './style.css'

const { Button } = require( 'react-bootstrap' )
const Autosuggest = require( 'react-autosuggest' )
const classnames = require( 'classnames' )
const { TextInput, LabelGroup, Flex } = require( '../../views' )

class WhereValueEditor extends React.Component {

  static TYPE = 'whereValue'

  static propTypes = {
    disabled : PropTypes.bool,
    where : PropTypes.array.isRequired,
    onChange : PropTypes.func,
    index : PropTypes.number.isRequired,
    create : PropTypes.bool,
    aliasSuggestions : PropTypes.array
  };

  static defaultProps = {
    disabled : false,
    create : false,
    onChange : () => {},
    aliasSuggestions : []
  };

  static getType = ( val ) => {
    let t = typeof val
    if ( t === 'object' && val == null || t === 'undefined' ) {
      t = 'null'
    }
    return t
  }

  static operators = [
    { description : 'equal to', symbol : '=' },
    { description : 'greater than', symbol : '>' },
    { description : 'less than', symbol : '<' },
    { description : 'greater than or equal to', symbol : '>=' },
    { description : 'less than or equal to', symbol : '<=' },
    { description : 'not equal to', symbol : '<>' },
    // { description : 'IN', symbol : 'IN' },
    { description : 'LIKE', symbol : 'LIKE', types : [ 'string' ], default : '' },
    { description : 'NOT LIKE', symbol : 'NOT LIKE', types : [ 'string' ], default : '' }
  ]

  constructor( props, context ) {
    super( props, context )
    const { where } = props

    this.state = {
      suggestions : [],
      type : 'null',
      partialAlias : where && where[0]
    }

  }

  componentDidUpdate( prevProps ) {
    const { where : oldWhere } = prevProps
    const { where } = this.props

    if ( where[0] != oldWhere[0] ) {
      this.setState( { partialAlias : where && where[0] } )
    }

  }

  onChangeSuggestionInput = ( event, { newValue } ) => {
    this.setState( {
      partialAlias : newValue
    } )
  }

  onChangeAlias = ( newAlias ) => {
    const { onChange, index, where } = this.props
    onChange( { index, item : [ newAlias, ...where.slice( 1 ) ] } )
  }

  onChangeOperator = ( { value : symbol } ) => {
    const { onChange, index, where } = this.props
    onChange( { index, item : [ where[0], symbol, ...where.slice( 2 ) ] } )
  }

  onChangeValue = ( newValue ) => {
    const { onChange, index, where } = this.props
    let val
    try {
      val = JSON.parse( newValue )
    } catch ( ex ) {
      val = newValue || null
    }
    onChange( { index, item : [ where[0], where[1], val ] } )
  }

  onCreate = () => {
    const { onChange, index } = this.props
    onChange( { index, action : 'create' } )
  }

  onCreateAnd = () => {
    const { onChange, index } = this.props
    onChange( { index, action : 'createAnd' } )
  }

  onCreateOr = () => {
    const { onChange, index } = this.props
    onChange( { index, action : 'createOr' } )
  }

  onDelete = () => {
    const { onChange, index } = this.props
    onChange( { index, action : 'delete' } )
  }

  onSuggestionsFetchRequested = ( { value, ...rest } ) => {
    const { aliasSuggestions } = this.props
    const suggestions = aliasSuggestions.filter( ( suggestion ) => {
      return suggestion && suggestion.path && suggestion.path.includes( value )
    } )
    this.setState( {
      suggestions
    } )
  }

  onSuggestionsClearRequested = () => {
    this.setState( {
      suggestions : []
    } )
  }

  getSuggestionValue = ( suggestion ) => {
    return suggestion && suggestion.path
  }

  renderContainer = ( { containerProps, children, query } ) => {
    return (
      <div {...containerProps} className={classnames( containerProps.className || '', style.suggestionsContainer )}>
        {children}
      </div>
    )
  }

  onSuggestionSelected = ( event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method } ) => {
    if ( suggestion && suggestion.path ) {
      this.onChangeAlias( suggestion.path )
    }
  }

  onInputBlur = () => {
    const { partialAlias } = this.state
    this.onChangeAlias( partialAlias )
  }

  onInputKeyPress = ( event ) => {
    const { partialAlias } = this.state
    if ( event.charCode === 13 ) {
      this.onChangeAlias( partialAlias )
    }
  }

  renderSuggestion = ( suggestion ) => {
    const { partialAlias } = this.state

    let start = '', highlight = '', end = ''
    if ( suggestion && suggestion.path ) {
      const index = suggestion.path.indexOf( partialAlias )
      start = suggestion.path.slice( 0, index )
      highlight = suggestion.path.slice( index, index + partialAlias.length )
      end = suggestion.path.slice( index + partialAlias.length )
    }
    return (
      <div className={style.suggestion}>
        <div>
          {start}
        </div>
        <div className={style.highlighted}>
          {highlight}
        </div>
        <div>
          {end}
        </div>
      </div>
    )
  }

  render() {
    const { disabled, where, create } = this.props
    const { suggestions, partialAlias } = this.state

    let alias, operator, value, type
    if ( where ) {
      alias = where[0]
      operator = where[1]
      value = where[2]
      type = typeof value
      if ( value == null ) {
        type = 'null'
      }
    }

    const inputProps = {
      value : partialAlias || '',
      onChange : this.onChangeSuggestionInput,
      onBlur : this.onInputBlur,
      onKeyPress : this.onInputKeyPress,
      placeholder : 'column/alias'
    }

    return (
      <Flex className={style.whereEditor} direction="row" align="center">
        <Flex variant="noSpace" direction="column" align="flex-start">
          {/* {<label>
            Column:
          </label>} */}
          <Autosuggest
            suggestions={suggestions}
            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
            onSuggestionsClearRequested={this.onSuggestionsClearRequested}
            onSuggestionSelected={this.onSuggestionSelected}
            getSuggestionValue={this.getSuggestionValue}
            renderSuggestion={this.renderSuggestion}
            renderSuggestionsContainer={this.renderContainer}
            inputProps={inputProps}/>
        </Flex>
        <Flex variant="noSpace" direction="column" align="flex-start">
          {/* <label>
            Operator:
          </label> */}
          <Selector
            className={style.castDrop}
            valueKey="symbol"
            nameKey="symbol"
            values={WhereValueEditor.operators}
            value={operator}
            placeholder="Operator"
            onChange={this.onChangeOperator} />
        </Flex>
        <Flex variant="noSpace" direction="column" align="flex-start">
          {/* <label>
            Value (detected type of:
            {type}
            ):
          </label> */}
          <TextInput
            value={typeof value !== 'string' && value != null ? value.toString() : value}
            disabled={disabled}
            hint="value"
            onChange={this.onChangeValue} />
        </Flex>
        {
          !disabled &&
          (
            <div className={style.deleteWhere}>
              {
                create ?
                  (
                    <div>
                      <Button bsStyle="link" className={style.button} onClick={this.onCreate}>
                        <i className="fa fa-plus" />
                      </Button>
                      <Button className={style.button} bsStyle="link" onClick={this.onCreateAnd}>&&</Button>
                      <Button className={style.button} bsStyle="link" onClick={this.onCreateOr}>||</Button>
                    </div>
                  ) :
                  (
                    <Button
                      bsStyle="link"
                      className={classnames( style.deleteWhere, style.button )}
                      onClick={this.onDelete}>
                      <i className={create ? 'fa fa-plus' : 'fa fa-trash'} />
                    </Button>
                  )
              }
            </div>
          )
        }
      </Flex>
    )
  }
}

exports.WhereValueEditor = WhereValueEditor
